<template>
  <question-base-wrapper
    title="What would you like the insurance to cover?"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failed }"
      name="Property Cover Type"
      :vid="`${stepId}_property-cover-type`"
      rules="required"
      slim
    >
      <radio
        v-model="questionData.propertyCoverType"
        name="property-cover-type"
        class="ie-property-cover-type"
        column
        wide
        :error="failed"
        :items="propertyCoverTypeItems"
        :data-test="snakeCase(questionFields.propertyCoverType)"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

import IconBuilding from '!svg-inline-loader!@/assets/icons/icon-building.svg';
import IconContents from '!svg-inline-loader!@/assets/icons/icon-contents.svg';

export default {
  name: 'question-property-cover-type',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyCoverType'],
    };
  },
  computed: {
    propertyCoverTypeItems () {
      const types = this.helpers.createOptions({ source: this.constants.COVER_PROPERTY_COVER_TYPE });

      types.forEach(option => {
        if (option.value === 'B') {
          option.icon = IconBuilding;
          option.iconType = 'component';
          option.disabled = this.isBuildingCoverOptionsDisabled;
        }
        if (option.value === 'BC') {
          option.icon = [IconBuilding, IconContents];
          option.iconType = 'component';
          option.disabled = this.isBuildingCoverOptionsDisabled;
        }
        if (option.value === 'C') {
          option.icon = IconContents;
          option.iconType = 'component';
        }
      });

      return types;
    },

    isHomeRenting () {
      return !this.constants.HOME_PROPERTY_OWNED_FAVORITES.includes(this.stepData.propertyOwned);
    },

    isBuildingCoverOptionsDisabled () {
      const isPropertyOwnedSelected = this.stepData.propertyOwned || this.stepData.propertyOwned === '';
      return isPropertyOwnedSelected && this.isHomeRenting;
    },

    shouldQuestionRender () {
      return this.config?.customPartner === 'boomin' || !this.isHomeRenting;
    },
  },
  created () {
    this.$watch('stepData.propertyOwned', (propertyOwned, propertyOwnedPrev) => {
      if (!propertyOwned || this.isHomeRenting) {
        this.setOnlyContentsCover();
        return;
      }

      // don't reset coverType for boomin on propertyOwned change
      if (this.config.customPartner === 'boomin') return;

      if (propertyOwned.includes('Y') && !propertyOwnedPrev?.includes('Y')) {
        this.setBuildingsAndContentsCover();
      }
    },
    { immediate: !this.stepData.propertyOwned });
  },
  methods: {
    setOnlyContentsCover () {
      this.questionData.propertyCoverType = this.constants.COVER_PROPERTY_COVER_TYPE_RENTING; // C
    },
    setBuildingsAndContentsCover () {
      this.questionData.propertyCoverType = this.constants.COVER_PROPERTY_COVER_TYPE_NOT_RENTING; // BC
    },
  },
};
</script>
